import { PREFIXO_EMBUTIDO } from "./rotas";

// WhatsApp da landing page que abriu o chat (o faq.js manda ?whatsapp=<número> no endereço do
// iframe): ali quem pergunta ainda não é cliente, então o "falar com atendente" vai para o time de
// vendas da página, no lugar dos atendentes do suporte. No "Ajuda" dos painéis não vem número e
// nada muda.
const CHAVE = "central:whatsapp-lp";
let emMemoria: string | null = null;

const numeroValido = (valor: string | null) => (valor && /^\d{10,15}$/.test(valor) ? valor : null);

// Só vale com o chat dentro de outra página (iframe da LP). Aberto direto no navegador, o número do
// endereço é ignorado: senão um link suporte.com.br/embed?...&whatsapp=<outro número> levaria o
// "falar com o time" da página oficial para o WhatsApp de quem mandou o link.
const dentroDeOutraPagina = () => {
  try {
    return window.self !== window.top;
  } catch {
    return true; // o navegador não deixa ler o topo: está dentro de outro site
  }
};

// Chamado na entrada do chat embutido (/embed?app=...): guarda o número ou apaga o de antes.
export const guardarWhatsAppDaPagina = (valor: string | null) => {
  emMemoria = dentroDeOutraPagina() ? numeroValido(valor) : null;
  try {
    if (emMemoria) sessionStorage.setItem(CHAVE, emMemoria);
    else sessionStorage.removeItem(CHAVE);
  } catch {
    // sem sessionStorage, fica só na memória
  }
};

// Chat aberto por uma landing page (o faq.js manda &lp=1): as métricas gravam o canal "lp", separado
// do "Ajuda" dos painéis, para a aba "Landing pages" do painel.
const CHAVE_LP = "central:lp";
let lpEmMemoria = false;
export const guardarOrigemLp = (valor: string | null) => {
  lpEmMemoria = dentroDeOutraPagina() && valor === "1";
  try {
    if (lpEmMemoria) sessionStorage.setItem(CHAVE_LP, "1");
    else sessionStorage.removeItem(CHAVE_LP);
  } catch {
    // sem sessionStorage, fica só na memória
  }
};
export const chatDeLp = (): boolean => {
  if (!window.location.pathname.startsWith(PREFIXO_EMBUTIDO)) return false;
  if (lpEmMemoria) return true;
  try {
    return sessionStorage.getItem(CHAVE_LP) === "1";
  } catch {
    return false;
  }
};

export const whatsAppDaPagina = (): string | null => {
  if (!window.location.pathname.startsWith(PREFIXO_EMBUTIDO)) return null;
  if (emMemoria) return emMemoria;
  try {
    return numeroValido(sessionStorage.getItem(CHAVE));
  } catch {
    return null;
  }
};
